export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "admin-home",
    icon: "PieChartIcon",
    permission: "life.admin.dashboard.menu.show",
    roles: ['Admin', 'VenueAdmin']
  },
  {
    url: "/users",
    name: "Users",
    slug: "admin-users",
    icon: "UsersIcon",
    permission: "life.admin.users.menu.show",
    roles: ['Admin', 'VenueAdmin']
  },
  /*{
    url: "/venues",
    name: "Venues",
    slug: "admin-venues",
    icon: "HomeIcon",
    permission: "life.admin.venues.menu.show",
    roles: ['Admin']
  },*/
  {
    url: "/content",
    name: "Content",
    slug: "admin-content",
    icon: "FileIcon",
    permission: "life.admin.content.menu.show",
    roles: ['Admin']
  },
  {
    url: "/role-management",
    name: "Roles",
    slug: "role-management",
    icon: "ShieldIcon",
    permission: "life.admin.roles.show",
    roles: ['Admin']
  },
  {
    url: "/surveys",
    name: "Surveys",
    slug: "admin-surveys",
    icon: "ZapIcon",
    permission: "life.admin.surveys.menu.show",
    roles: ['Admin']
  },
  {
    url: "/whistleblower",
    name: "Whistleblower",
    slug: "admin-whistleblower",
    icon: "MehIcon",
    permission: "life.admin.whistleblower.seeadd",
    roles: ['Admin']
  },
  {
    url: "/venue-training",
    name: "Events",
    slug: "admin-venue-trainings",
    icon: "BookIcon",
    permission: "life.admin.campus.menu.show",
    roles: ['Admin', 'VenueAdmin']
  },
  {
    url: "/calendar",
    name: "Calendar",
    slug: "admin-calendar",
    icon: "CalendarIcon",
    permission: "life.admin.calendar.menu.show",
    roles: ['Admin', 'VenueAdmin']
  },
  /*{
    url: "/planday",
    name: "Planday",
    slug: "admin-planday",
    icon: "SettingsIcon",
    permission: "life.admin.planday.menu.show",
    roles: ['Admin']
  },*/
  {
    url: "/wall",
    name: "Wall",
    slug: "admin-wall",
    icon: "HashIcon",
    permission: "life.admin.wall.menu.show",
    roles: ['Admin']
  },
]
